import { HttpMethod } from '@nu-art/thunderstorm-shared';
export const ApiDef_Analytics = (baseUrl) => ({
    _v1: {
        sendEvent: { baseUrl, method: HttpMethod.POST, path: '/v1/analytics/send-event' },
        updateUser: { baseUrl, method: HttpMethod.POST, path: '/v1/analytics/update-user' },
        updateLexicon: { baseUrl, method: HttpMethod.POST, path: '/v1/analytics/update-lexicon' },
    }
});
//# sourceMappingURL=api-def.js.map